<template>
  <div class="auth">
    <p class="auth__title-standart">Завершение регистрации</p>
    <p class="auth__subtitle-standart">
      Введите ваш email и придумайте пароль, чтобы закончить регистрацию
    </p>
    <form class="auth__form" @submit.prevent="register">
      <label
        class="auth__form-block"
        :class="{
          '-error-':
            error('email').message || ($v.$dirty && $v.user.email.$invalid)
        }"
      >
        <input
          v-model.trim="user.email"
          class="auth__form-input"
          type="text"
          placeholder="Email"
        />
        <span
          v-if="$v.$dirty && !$v.user.email.required"
          class="auth__form-error"
        >
          Введите email
        </span>
        <span
          v-else-if="$v.$dirty && !$v.user.email.email"
          class="auth__form-error"
        >
          Некорректный email
        </span>
        <span v-else class="auth__form-error">
          {{ error('email').message }}
        </span>
      </label>

      <label
        :class="{
          '-error-':
            error('plainPassword').message ||
            ($v.$dirty && $v.user.plainPassword.$invalid)
        }"
        class="auth__form-block"
      >
        <input
          v-model="user.plainPassword"
          class="auth__form-input"
          type="password"
          placeholder="Пароль"
        />
        <span
          v-if="$v.user.plainPassword.$dirty && !$v.user.plainPassword.required"
          class="auth__form-error"
        >
          Введите пароль
        </span>
        <span
          v-else-if="
            $v.user.plainPassword.$dirty && !$v.user.plainPassword.minLength
          "
          class="auth__form-error"
        >
          Минимальная длина пароля
          {{ $v.user.plainPassword.$params.minLength.min }} символов
        </span>
        <span v-else class="auth__form-error">
          {{ error('plainPassword').message }}
        </span>
      </label>

      <button class="auth__form-button">Создать аккаунт</button>

      <label class="checkbox auth__form-block auth__form-block--checkbox">
        <input
          v-model="user.agreeTerms"
          :true-value="1"
          :false-value="0"
          type="checkbox"
          class="checkbox__input"
          hidden
        />
        <span class="checkbox__icon auth__form-checkbox">
          <transition name="fadePreloader">
            <Icon
              v-if="!!user.agreeTerms"
              class="auth__form-checkbox-svg"
              icon="check-icon"
            />
          </transition>
        </span>
        <span class="auth__form-checkbox-text"
          >Оставляя данные, вы принимаете условия
          <a
            href="https://docs.google.com/document/d/1l9I4EyDn7thrLgVAWwM-Eh4r_B5XS-2r-3m6dbZT0J0/edit?usp=sharing"
            target="_blank"
            class="checkbox__link hover__link"
            >Политики конфиденциальности</a
          >
          и
          <a
            href="https://docs.google.com/document/d/1Z4I_yLTtUeJxyKyV8Ps6dcoYHQFZX7_A4sQlG8595pM/edit?usp=sharing"
            target="_blank"
            class="checkbox__link hover__link"
            >Оферты</a
          >
        </span>
      </label>
      <span
        v-if="$v.$dirty && !!!user.agreeTerms"
        style="position: relative"
        class="auth__form-error"
        >Примите условия политики конфиденциальности</span
      >
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { required, email, minLength } from 'vuelidate/lib/validators';

export default {
  data: () => ({
    user: {
      email: '',
      plainPassword: '',
      agreeTerms: 1
    }
  }),
  computed: {
    ...mapState('security', {
      registering: s => s.meta.registering,
      errors: s => s.data.authErrors
    }),
    error() {
      return field =>
        this.errors.length > 0
          ? this.errors.find(e => e.field === field)
            ? this.errors.find(e => e.field === field)
            : { message: '' }
          : { message: '' };
    }
  },
  destroyed() {
    if (this.errors.length > 0) {
      this.$store.dispatch('security/clearAuthErrors');
    }
  },
  methods: {
    register() {
      if (this.registering) {
        return;
      }
      if (this.$v.$invalid || !this.user.agreeTerms) {
        this.$v.$touch();
        return;
      }

      this.$store.dispatch('security/register', this.user);
    }
  },
  validations: {
    user: {
      email: { required, email },
      plainPassword: { required, minLength: minLength(6) }
    }
  }
};
</script>
